var React = require('react');

function IcArrowBackComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-arrow back"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M16.3132 10.8331L16.3132 10.8331L6.1674 10.8331L16.3132 10.8331ZM10.8341 4.49976L6.1674 9.16645L10.8341 4.49978L10.8341 4.49976ZM10.4789 4.50134L5.56385 9.41644L16.0632 9.41644L16.0632 10.5831L5.56385 10.5831L10.4789 15.4982L9.64812 16.3145L3.33345 9.99978L9.64812 3.6851L10.4789 4.50134Z","fill":"#3E3E3E"})));
}

IcArrowBackComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcArrowBackComponent;

IcArrowBackComponent.default = IcArrowBackComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/MyTarifSectionV2/images/ic-arrow-back.component.svg
// module id = 1639
// module chunks = 0